const AI_NAME = 'Orca AI';

export const AI_STRINGS = {
  buttons: {
    default: AI_NAME,
    short: 'AI',
    search: AI_NAME + ' search',
    prefill: AI_NAME + ' prefill',
  },
  placeholders: {
    ask: 'Ask ' + AI_NAME + '...',
    search: AI_NAME + ' is searching for ',
    charts: 'AI Charts will be here',
    canVisualize: AI_NAME + ' can visualize data',
  },
  error: 'AI assistant is experiencing high demand. Please wait a moment and try again.',
};
